import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=047b1289&scoped=true&"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalBarChart.vue?vue&type=style&index=0&id=047b1289&prod&lang=scss&scoped=true&"
import style1 from "./HorizontalBarChart.vue?vue&type=style&index=1&id=047b1289&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b1289",
  null
  
)

export default component.exports